import _ from "lodash";

import store from "../reduxStore";
import locales from "constants/locales";

export const getSelectedData = (
  items,
  checkedRows,
  oldSelectedData,
  idKey = "Id"
) => {
  const selectedIds = _(checkedRows)
    .keys()
    .map(_.toNumber)
    .value();
  let selectedData = _.cloneDeep(oldSelectedData);

  _.forEach(items, item => {
    if (
      _.includes(selectedIds, +item.Id) &&
      !_.find(oldSelectedData, [idKey, item.Id])
    ) {
      selectedData.push({
        id: item.Id,
        [idKey]: item.Id,
        documentId: item.DocumentId
      });
    }
  });

  selectedData = _.filter(selectedData, ({ id }) =>
    _.includes(selectedIds, +id)
  );

  return selectedData;
};

export const getTranslation = id => {
  let language = "nl";
  if (store) {
    const state = store.getState();
    language = _.get(state, "app.user.profile.Language", "nl");
  }

  return locales[language][id];
};

export const getOptions = (data, name) => {
  const value = _.find(data, ["Name", name]);
  const options = value ? value.Options : [];
  const result = options.map(o => ({ label: o.Name, value: o.Value }));
  return result;
};
